import { createStore, applyMiddleware } from 'redux'
import rootReducer from '../_reducers'
import thunkMiddleware from 'redux-thunk';

export const store = createStore(
		rootReducer,
		applyMiddleware(
			thunkMiddleware
			)
		);



// WEBPACK FOOTER //
// ./src/_helpers/store.js